import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../assets/images/welcome/besc.png'


const _hoisted_1 = {
  key: 0,
  class: "row align-items-stretch mb-25"
}
const _hoisted_2 = { class: "col-lg-4 col-md-12 mb-25 mb-lg-0" }
const _hoisted_3 = { class: "card border-0 rounded-0 welcome-box h-100" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20" }
const _hoisted_5 = { class: "row align-items-center h-100" }
const _hoisted_6 = { class: "col-7" }
const _hoisted_7 = { class: "fw-semibold mb-8" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { class: "col-lg col-sm-4 mb-25 mb-lg-0" }
const _hoisted_10 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_11 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "flex-grow-1 ms-3" }
const _hoisted_14 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"28px"}
}
const _hoisted_15 = { class: "col-lg col-sm-4 mb-25 mb-lg-0" }
const _hoisted_16 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_17 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = { class: "flex-grow-1 ms-3" }
const _hoisted_20 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"28px"}
}
const _hoisted_21 = { class: "col-lg col-sm-4 mb-25 mb-lg-0" }
const _hoisted_22 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_23 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { class: "flex-grow-1 ms-3" }
const _hoisted_26 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"28px"}
}
const _hoisted_27 = { class: "col-12 mt-25" }
const _hoisted_28 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_29 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_30 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_31 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_32 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_33 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_34 = { class: "table align-middle mb-0" }
const _hoisted_35 = { class: "fw-medium" }
const _hoisted_36 = { class: "badge bg-primary" }
const _hoisted_37 = { class: "text-end" }
const _hoisted_38 = { class: "dropdown" }
const _hoisted_39 = { class: "dropdown-menu" }
const _hoisted_40 = { class: "col-12 mt-25" }
const _hoisted_41 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_42 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_43 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_44 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_45 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_46 = { class: "table align-middle mb-0" }
const _hoisted_47 = { class: "fw-medium" }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "text-end" }
const _hoisted_51 = { class: "dropdown" }
const _hoisted_52 = { class: "dropdown-menu" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = {
  key: 1,
  class: "row align-items-stretch mb-25"
}
const _hoisted_55 = { class: "col-lg-4 col-md-12 mb-25 mb-lg-0" }
const _hoisted_56 = { class: "card border-0 rounded-0 welcome-box h-100" }
const _hoisted_57 = { class: "card-body p-15 p-sm-20" }
const _hoisted_58 = { class: "row align-items-center h-100" }
const _hoisted_59 = { class: "col-7" }
const _hoisted_60 = { class: "fw-semibold mb-8" }
const _hoisted_61 = { class: "fw-bold" }
const _hoisted_62 = { class: "col-lg col-sm-4 mb-25 mb-lg-0" }
const _hoisted_63 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_64 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = { class: "flex-grow-1 ms-3" }
const _hoisted_67 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"28px"}
}
const _hoisted_68 = { class: "col-lg col-sm-4 mb-25 mb-lg-0" }
const _hoisted_69 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_70 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_71 = { class: "d-flex align-items-center" }
const _hoisted_72 = { class: "flex-grow-1 ms-3" }
const _hoisted_73 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"28px"}
}
const _hoisted_74 = { class: "col-lg col-sm-4 mb-25 mb-lg-0" }
const _hoisted_75 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_76 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_77 = { class: "d-flex align-items-center" }
const _hoisted_78 = { class: "flex-grow-1 ms-3" }
const _hoisted_79 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"28px"}
}
const _hoisted_80 = { class: "col-12 mt-25" }
const _hoisted_81 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_82 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_83 = { class: "fw-bold text-black mb-0" }
const _hoisted_84 = { class: "d-flex gap-2" }
const _hoisted_85 = { class: "btn-group me-2" }
const _hoisted_86 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_87 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_88 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_89 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_90 = { class: "table align-middle mb-0" }
const _hoisted_91 = {
  key: 0,
  class: "text-end"
}
const _hoisted_92 = { class: "fw-medium" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { class: "text-muted small" }
const _hoisted_95 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { class: "text-muted small" }
const _hoisted_98 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_99 = {
  key: 0,
  class: "text-end"
}
const _hoisted_100 = { class: "dropdown" }
const _hoisted_101 = { class: "dropdown-menu" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = ["onClick"]
const _hoisted_104 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_105 = {
  key: 2,
  class: "row align-items-stretch mb-25"
}
const _hoisted_106 = { class: "col-lg-4 col-md-12 mb-25 mb-lg-0" }
const _hoisted_107 = { class: "card border-0 rounded-0 welcome-box h-100" }
const _hoisted_108 = { class: "card-body p-15 p-sm-20" }
const _hoisted_109 = { class: "row align-items-center h-100" }
const _hoisted_110 = { class: "col-7" }
const _hoisted_111 = { class: "fw-semibold mb-8" }
const _hoisted_112 = { class: "fw-bold" }
const _hoisted_113 = { class: "col-lg col-sm-4 mb-25 mb-lg-0" }
const _hoisted_114 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_115 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_116 = { class: "d-flex align-items-center" }
const _hoisted_117 = { class: "flex-grow-1 ms-3" }
const _hoisted_118 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"28px"}
}
const _hoisted_119 = { class: "col-lg col-sm-4 mb-25 mb-lg-0" }
const _hoisted_120 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_121 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_122 = { class: "d-flex align-items-center" }
const _hoisted_123 = { class: "flex-grow-1 ms-3" }
const _hoisted_124 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"28px"}
}
const _hoisted_125 = { class: "col-lg col-sm-4 mb-25 mb-lg-0" }
const _hoisted_126 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_127 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_128 = { class: "d-flex align-items-center" }
const _hoisted_129 = { class: "flex-grow-1 ms-3" }
const _hoisted_130 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"28px"}
}
const _hoisted_131 = { class: "col-12 mt-25" }
const _hoisted_132 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_133 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_134 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_135 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_136 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_137 = { class: "table align-middle mb-0" }
const _hoisted_138 = { class: "fw-medium" }
const _hoisted_139 = ["innerHTML"]
const _hoisted_140 = { class: "text-end" }
const _hoisted_141 = { class: "dropdown" }
const _hoisted_142 = { class: "dropdown-menu" }
const _hoisted_143 = { key: 0 }
const _hoisted_144 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_ctx.checkRole('Agent'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h3", _hoisted_7, [
                    _cache[4] || (_cache[4] = _createTextVNode(" Bonjour, ", -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.userName ? _ctx.userName : "") + "!", 1)
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "d-block text-black-emphasis fs-md-15" }, " Votre espace de validation. Chaque contrôle effectué garantit la conformité des dossiers. ", -1))
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-5 text-center" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "welcome-image",
                    class: "img-fluid"
                  })
                ], -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", {
                    class: "flaticon-folder text-primary",
                    style: {"font-size":"36px"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.stats.totalFiles), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Files assignées", -1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", {
                    class: "flaticon-check text-success",
                    style: {"font-size":"36px"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.stats.completedTasks), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Dossiers traités", -1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", {
                    class: "flaticon-time text-warning",
                    style: {"font-size":"36px"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.stats.pendingTasks), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "En Validation", -1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "fw-bold text-black mb-0" }, "Mes Files de Validation", -1)),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadAgentData && _ctx.loadAgentData(...args))),
                class: "btn btn-outline-primary btn-sm"
              }, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
                _createTextVNode(" Actualiser ", -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_30, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                    ], -1)
                  ]))]))
                : (_ctx.assignedQueues.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("p", { class: "text-muted" }, "Aucune file assignée pour le moment", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("table", _hoisted_34, [
                        _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Nom de la file"),
                            _createElementVNode("th", null, "Code"),
                            _createElementVNode("th", null, "Niveau de risque"),
                            _createElementVNode("th", null, "Nombre de dossiers"),
                            _createElementVNode("th", { class: "text-end" }, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignedQueues, (queue) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: queue.id
                            }, [
                              _createElementVNode("td", _hoisted_35, _toDisplayString(queue.name), 1),
                              _createElementVNode("td", null, _toDisplayString(queue.code), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", _ctx.getRiskBadgeClass(queue.maxRiskLevel)])
                                }, _toDisplayString(_ctx.getRiskLabel(queue.maxRiskLevel)), 3)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.getBescsCount(queue.id)) + " dossiers ", 1)
                              ]),
                              _createElementVNode("td", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _cache[18] || (_cache[18] = _createElementVNode("span", {
                                    class: "badge text-white bg-primary fs-15 dropdown-toggle",
                                    "data-bs-toggle": "dropdown",
                                    "aria-expanded": "false",
                                    style: {"cursor":"pointer"}
                                  }, [
                                    _createTextVNode(" Actions "),
                                    _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                                  ], -1)),
                                  _createElementVNode("ul", _hoisted_39, [
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_router_link, {
                                        to: { name: 'AgentFilesPage', query: { queueId: queue.id } },
                                        class: "dropdown-item d-flex align-items-center"
                                      }, {
                                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                          _createElementVNode("i", { class: "flaticon-folder-open lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Voir les dossiers ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["to"])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, [
              _createElementVNode("h4", { class: "fw-bold text-black mb-0" }, "Tâches Récentes")
            ], -1)),
            _createElementVNode("div", _hoisted_42, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                    ], -1)
                  ]))]))
                : (_ctx.recentTasks.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("p", { class: "text-muted" }, "Aucune tâche récente", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("table", _hoisted_46, [
                        _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Référence BESC"),
                            _createElementVNode("th", null, "File"),
                            _createElementVNode("th", null, "Statut"),
                            _createElementVNode("th", null, "Priorité"),
                            _createElementVNode("th", null, "Date limite"),
                            _createElementVNode("th", { class: "text-end" }, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentTasks, (task) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: task.id
                            }, [
                              _createElementVNode("td", _hoisted_47, _toDisplayString(task.validationTask.besc?.refbesc), 1),
                              _createElementVNode("td", null, _toDisplayString(task.validationTask.validationqueue?.name), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  innerHTML: _ctx.getStatusBadgeAgent(task.result)
                                }, null, 8, _hoisted_48)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  innerHTML: _ctx.getPriorityBadge(task.validationTask.priority)
                                }, null, 8, _hoisted_49)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(_ctx.format_date(task.validationTask.sla_due_at)), 1),
                              _createElementVNode("td", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _cache[23] || (_cache[23] = _createElementVNode("span", {
                                    class: "badge text-white bg-primary fs-15 dropdown-toggle",
                                    "data-bs-toggle": "dropdown",
                                    "aria-expanded": "false",
                                    style: {"cursor":"pointer"}
                                  }, [
                                    _createTextVNode(" Actions "),
                                    _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                                  ], -1)),
                                  _createElementVNode("ul", _hoisted_52, [
                                    (task.validationTask.besc?.id)
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                                          _createVNode(_component_router_link, {
                                            to: { name: 'ViewBesc', params: { id: task.validationTask.besc.id } },
                                            class: "dropdown-item d-flex align-items-center"
                                          }, {
                                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                              _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                                              _createTextVNode(" Détails ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["to"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
            ])
          ])
        ])
      ]))
    : (_ctx.checkRole('Superviseur'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("h3", _hoisted_60, [
                      _cache[26] || (_cache[26] = _createTextVNode(" Bonjour, ", -1)),
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.userName ? _ctx.userName : "") + "!", 1)
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "d-block text-black-emphasis fs-md-15" }, " Votre espace de supervision. Contrôlez et validez les dossiers traités par les agents. ", -1))
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-5 text-center" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "welcome-image",
                      class: "img-fluid"
                    })
                  ], -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("i", {
                      class: "flaticon-time text-warning",
                      style: {"font-size":"36px"}
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.stats.enAttente), 1),
                    _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "En validation", -1))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("i", {
                      class: "flaticon-check text-success",
                      style: {"font-size":"36px"}
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.stats.approuves), 1),
                    _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Approuvés", -1))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("i", {
                      class: "flaticon-close text-danger",
                      style: {"font-size":"36px"}
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.stats.rejetes), 1),
                    _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Rejetés", -1))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("h4", _hoisted_83, _toDisplayString(_ctx.viewModeSuperviseur === 'PENDING' ? 'Validations en attente' : 'Validations traitées'), 1),
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-sm", _ctx.viewModeSuperviseur === 'PENDING' ? 'btn-primary' : 'btn-outline-primary']),
                      onClick: _cache[1] || (_cache[1] = () => { _ctx.viewModeSuperviseur = 'PENDING'; _ctx.loadSuperviseurData(); })
                    }, " En validation ", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-sm", _ctx.viewModeSuperviseur === 'PROCESSED' ? 'btn-primary' : 'btn-outline-primary']),
                      onClick: _cache[2] || (_cache[2] = () => { _ctx.viewModeSuperviseur = 'PROCESSED'; _ctx.loadSuperviseurData(); })
                    }, " Traités ", 2)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loadSuperviseurData && _ctx.loadSuperviseurData(...args))),
                    class: "btn btn-outline-primary btn-sm"
                  }, [...(_cache[35] || (_cache[35] = [
                    _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
                    _createTextVNode(" Actualiser ", -1)
                  ]))])
                ])
              ]),
              _createElementVNode("div", _hoisted_86, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [...(_cache[36] || (_cache[36] = [
                      _createElementVNode("div", {
                        class: "spinner-border text-primary",
                        role: "status"
                      }, [
                        _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                      ], -1)
                    ]))]))
                  : (_ctx.validations.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [...(_cache[37] || (_cache[37] = [
                        _createElementVNode("p", { class: "text-muted" }, "Aucune validation en attente", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_89, [
                        _createElementVNode("table", _hoisted_90, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _cache[38] || (_cache[38] = _createElementVNode("th", null, "Référence BESC", -1)),
                              _cache[39] || (_cache[39] = _createElementVNode("th", null, "Agent", -1)),
                              _cache[40] || (_cache[40] = _createElementVNode("th", null, "File", -1)),
                              _createElementVNode("th", null, _toDisplayString(_ctx.viewModeSuperviseur === 'PENDING' ? 'Date terminé' : 'Date validation'), 1),
                              _cache[41] || (_cache[41] = _createElementVNode("th", null, "Statut", -1)),
                              (_ctx.viewModeSuperviseur === 'PENDING')
                                ? (_openBlock(), _createElementBlock("th", _hoisted_91, "Actions"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validations, (validation) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: validation.id
                              }, [
                                _createElementVNode("td", _hoisted_92, _toDisplayString(validation.refbesc), 1),
                                _createElementVNode("td", null, [
                                  (validation.assignedAgent)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                        _createTextVNode(_toDisplayString(validation.assignedAgent.nom) + " " + _toDisplayString(validation.assignedAgent.prenom) + " ", 1),
                                        _createElementVNode("div", _hoisted_94, _toDisplayString(validation.assignedAgent.email), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_95, "—"))
                                ]),
                                _createElementVNode("td", null, [
                                  (validation.queue)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                        _createTextVNode(_toDisplayString(validation.queue.name) + " ", 1),
                                        _createElementVNode("div", _hoisted_97, _toDisplayString(validation.queue.code), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_98, "—"))
                                ]),
                                _createElementVNode("td", null, _toDisplayString(_ctx.viewModeSuperviseur === 'PENDING' ? _ctx.format_date(validation.completedAt) : _ctx.format_date(validation.supervisorValidatedAt)), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["badge", _ctx.getStatusClassSuperviseur(validation.supervisorDecision)])
                                  }, _toDisplayString(_ctx.getStatusLabelSuperviseur(validation.supervisorDecision)), 3)
                                ]),
                                (_ctx.viewModeSuperviseur === 'PENDING')
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_99, [
                                      _createElementVNode("div", _hoisted_100, [
                                        _cache[44] || (_cache[44] = _createElementVNode("span", {
                                          class: "badge text-white bg-primary fs-15 dropdown-toggle",
                                          "data-bs-toggle": "dropdown",
                                          "aria-expanded": "false",
                                          style: {"cursor":"pointer"}
                                        }, [
                                          _createTextVNode(" Actions "),
                                          _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                                        ], -1)),
                                        _createElementVNode("ul", _hoisted_101, [
                                          _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                              href: "javascript:void(0);",
                                              onClick: ($event: any) => (_ctx.approuverValidation(validation.id)),
                                              class: "dropdown-item d-flex align-items-center"
                                            }, [...(_cache[42] || (_cache[42] = [
                                              _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                              _createTextVNode(" Approuver ", -1)
                                            ]))], 8, _hoisted_102)
                                          ]),
                                          _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                              href: "javascript:void(0);",
                                              onClick: ($event: any) => (_ctx.rejeterValidation(validation.id)),
                                              class: "dropdown-item d-flex align-items-center"
                                            }, [...(_cache[43] || (_cache[43] = [
                                              _createElementVNode("i", { class: "flaticon-close lh-1 me-8 position-relative top-1" }, null, -1),
                                              _createTextVNode(" Rejeter ", -1)
                                            ]))], 8, _hoisted_103)
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])),
                _createElementVNode("div", _hoisted_104, [
                  _createVNode(_component_PaginationComponent, {
                    page: _ctx.pageSuperviseur,
                    totalPages: _ctx.totalPagesSuperviseur,
                    totalElements: _ctx.totalElementsSuperviseur,
                    limit: _ctx.limitSuperviseur,
                    onPaginate: _ctx.handlePaginateSuperviseur
                  }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
                ])
              ])
            ])
          ])
        ]))
      : (_ctx.checkRole('Transitaire'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("h3", _hoisted_111, [
                        _cache[45] || (_cache[45] = _createTextVNode(" Bonjour, ", -1)),
                        _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.userName ? _ctx.userName : "") + "!", 1)
                      ]),
                      _cache[46] || (_cache[46] = _createElementVNode("span", { class: "d-block text-black-emphasis fs-md-15" }, " Votre espace de gestion BESC. Chaque dossier soumis est un pas vers une exportation réussie.. ", -1))
                    ]),
                    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col-5 text-center" }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "welcome-image",
                        class: "img-fluid"
                      })
                    ], -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_113, [
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, [
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", {
                        class: "flaticon-folder text-primary",
                        style: {"font-size":"36px"}
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_117, [
                      _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.stats.totalDossiers), 1),
                      _cache[48] || (_cache[48] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Dossiers totaux", -1))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("div", _hoisted_120, [
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("div", _hoisted_122, [
                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", {
                        class: "flaticon-check text-success",
                        style: {"font-size":"36px"}
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.stats.dossiersValides), 1),
                      _cache[50] || (_cache[50] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Dossiers validés", -1))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("div", _hoisted_126, [
                _createElementVNode("div", _hoisted_127, [
                  _createElementVNode("div", _hoisted_128, [
                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", {
                        class: "flaticon-time text-warning",
                        style: {"font-size":"36px"}
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.stats.dossiersEnValidation), 1),
                      _cache[52] || (_cache[52] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "En cours de validation", -1))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("div", _hoisted_132, [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, [
                  _createElementVNode("h4", { class: "fw-bold text-black mb-0" }, "Dossiers en Validation / Validés")
                ], -1)),
                _createElementVNode("div", _hoisted_133, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_134, [...(_cache[54] || (_cache[54] = [
                        _createElementVNode("div", {
                          class: "spinner-border text-primary",
                          role: "status"
                        }, [
                          _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                        ], -1)
                      ]))]))
                    : (_ctx.dossiers.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_135, [...(_cache[55] || (_cache[55] = [
                          _createElementVNode("p", { class: "text-muted" }, "Aucun dossier en validation ou validé", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_136, [
                          _createElementVNode("table", _hoisted_137, [
                            _cache[59] || (_cache[59] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Référence BESC"),
                                _createElementVNode("th", null, "Destination"),
                                _createElementVNode("th", null, "Statut"),
                                _createElementVNode("th", null, "Date création"),
                                _createElementVNode("th", null, "Date validation"),
                                _createElementVNode("th", { class: "text-end" }, "Actions")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dossiers, (dossier) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: dossier.id
                                }, [
                                  _createElementVNode("td", _hoisted_138, _toDisplayString(dossier.refbesc), 1),
                                  _createElementVNode("td", null, _toDisplayString(dossier.destination || '—'), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                      innerHTML: _ctx.getStatusBadge(dossier.status)
                                    }, null, 8, _hoisted_139)
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.format_date(dossier.created_at)), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.format_date(dossier.validated_at)), 1),
                                  _createElementVNode("td", _hoisted_140, [
                                    _createElementVNode("div", _hoisted_141, [
                                      _cache[58] || (_cache[58] = _createElementVNode("span", {
                                        class: "badge text-white bg-primary fs-15 dropdown-toggle",
                                        "data-bs-toggle": "dropdown",
                                        "aria-expanded": "false",
                                        style: {"cursor":"pointer"}
                                      }, [
                                        _createTextVNode(" Actions "),
                                        _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                                      ], -1)),
                                      _createElementVNode("ul", _hoisted_142, [
                                        _createElementVNode("li", null, [
                                          (dossier.id)
                                            ? (_openBlock(), _createBlock(_component_router_link, {
                                                key: 0,
                                                to: { name: 'ViewBesc', params: { id: dossier.id } },
                                                class: "dropdown-item d-flex align-items-center"
                                              }, {
                                                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                                  _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                                                  _createTextVNode(" Détails ", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["to"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (dossier.status === 'VALIDE')
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_143, [
                                              _createElementVNode("a", {
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.telechargerPDF(dossier.id)),
                                                class: "dropdown-item d-flex align-items-center"
                                              }, [...(_cache[57] || (_cache[57] = [
                                                _createElementVNode("i", { class: "flaticon-file-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Télécharger PDF ", -1)
                                              ]))], 8, _hoisted_144)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
}